import fetch from 'common/js/fetch';
import {getRoleCode} from 'common/js/util';
import {ROOT_MENU_CODE} from 'common/js/config';

/**
 * 获取当前菜单拥有的按钮列表
 * @param parentKey
 */
export function getOwnerBtns(parentId) {
    return fetch('/auth/v1/user/permission_none/permission/btn/' + parentId, {});
}

/**
 * 根据角色查询对应端菜单
 */
export function getRoleMenuTreeList(roleId) {
    return fetch('/auth/v1/role/menu_tree/' + roleId);
}

/**
 * 获取当前用户所有菜单
 */
export function getRoleMenuList() {
    return fetch('/auth/v1/user/permission_none/permission/menu', {type: 'menu'});
}

/**
 * 获取角色的菜单和按钮
 */
export function getRoleMenuBtnList(id) {
    return fetch('/auth/v1/role/permission_list/' + id);
}

/**
 * 列表查询接口
 * @param type 类型(query/operate)
 */
export function getActionList() {
    return fetch('/auth/v1/action/list', {});
}

/**
 * 获取当前菜单所有的接口
 * @param menuId 菜单编号
 */
export function getMenuActionList(menuId) {
    return fetch('/auth/v1/menu/action_list/' + menuId);
}

/**
 * 获取当前菜单所有的接口
 * @param menuId 菜单编号
 */
export function getMenuDetail(menuId) {
    return fetch('/auth/v1/menu/detail/' + menuId);
}

/**
 * 为菜单分配接口
 * @param id 菜单编号
 * @param actionIdList 接口数组
 */
export function distributionAction({id, actionIdList}) {
    return fetch('/auth/v1/menu/allot_action', {id, actionIdList});
}

// 分配菜单权限
export function setRoleMenus(resourceIdList, id) {
    return fetch('/auth/v1/role/allot_permission', {
        menuIdList: resourceIdList,
        roleId: id
    });
}

/**
 * 删除菜单
 * @param id 菜单编号
 */
export function deleteMenuById(id) {
    return fetch('/auth/v1/group/remove/' + id);
}

/**
 * 修改菜单
 * @param id 菜单编号
 */
export function editMenuById({id, name, parentId, remark, orderNo}) {
    return fetch('/auth/v1/group/modify', {id, name, parentId, remark, orderNo});
}

/**
 * 修改菜单
 * @param id 菜单编号
 */
export function addMenu({id, name, parentId, remark, orderNo}) {
    return fetch('/auth/v1/group/create', {id, name, parentId, remark, orderNo});
}

/**
 * 列表菜单
 * @params parentId
 * @params url
 * @params name
 * @params type
 */
export function getMenuList(params) {
    return fetch('/auth/v1/group/list', params);
}

/**
 * 目录管理
 * @params parentId
 * @params url
 * @params name
 * @params type
 */
export function getDirList(params) {
    return fetch('/core/v1/knowledge_catalog/list', params);
}

/**
 * 添加目录
 * @param id 菜单编号
 */
export function addDir(params) {
    return fetch('/core/v1/knowledge_catalog/create', params);
}

/**
 * 修改目录
 * @param id 菜单编号
 */
export function editDirById(params) {
    return fetch('/core/v1/knowledge_catalog/modify', params);
}

/**
 * 删除目录
 * @param id 菜单编号
 */
export function deleteDirById(id) {
    return fetch('/core/v1/knowledge_catalog/remove/' + id);
}

/**
 * 列表菜单
 */
export function getMenuActionTreeList() {
    return fetch('/auth/v1/user/client/menu');
}
